
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kgUsc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "MeatballMenu", () => $30107a31e93752a7$export$ef4a0fdddd7eccb7);
$parcel$export(module.exports, "default", () => $30107a31e93752a7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $NByNW = parcelRequire("NByNW");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $4jUsx = parcelRequire("4jUsx");

var $l2S61 = parcelRequire("l2S61");

var $gguUc = parcelRequire("gguUc");

var $b1GOu = parcelRequire("b1GOu");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cxKOj = parcelRequire("cxKOj");

var $2rQxZ = parcelRequire("2rQxZ");

var $lJU2B = parcelRequire("lJU2B");

var $hAtbw = parcelRequire("hAtbw");
const $30107a31e93752a7$export$ef4a0fdddd7eccb7 = ({ issueId: issueId, issueKey: issueKey, workType: workType, isCreateSubTaskAllowed: isCreateSubTaskAllowed, onIssueRefetch: onIssueRefetch, onAddFlag: onAddFlag, onIssueDelete: onIssueDelete })=>{
    const [isOpen, setOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fetchData: fetchData, state: state } = (0, $gguUc.default)();
    const { rankToTopQuery: rankToTopQuery, rankToBottomQuery: rankToBottomQuery } = (0, $b1GOu.default)();
    const { approveApproval: approveApproval, rejectApproval: rejectApproval } = (0, $4jUsx.default)();
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions } = (0, $l2S61.default)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleChange = (0, $eJOHy.useCallback)((newOpenState)=>{
        setOpen(newOpenState);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownMenu',
            attributes: {
                isOpen: newOpenState
            }
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'issueOperationsMeatballMenu');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        const wasClosed = !isOpen && state.loading === false && uploadPermissions.loading === false;
        if (wasClosed) {
            if (state.data === undefined) fetchData(issueId);
            if (uploadPermissions.permissions === null) fetchUploadPermissions(issueId);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.JIRA.IssueNavigator.getSelectedIssueKey = ()=>issueKey;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.JIRA.IssueNavigator.getSelectedIssueId = ()=>issueId;
        }
        handleChange(!isOpen);
    };
    const onRefetch = ()=>{
        onIssueRefetch && onIssueRefetch(issueKey);
        fetchData(issueId);
    };
    const onDelete = ()=>{
        onIssueDelete && onIssueDelete(issueKey);
    };
    const onRetry = ()=>{
        fetchData(issueId);
    };
    const onRankToTop = (onSuccess, onFailure)=>{
        rankToTopQuery(issueId, onSuccess, onFailure);
    };
    const onRankToBottom = (onSuccess, onFailure)=>{
        rankToBottomQuery(issueId, onSuccess, onFailure);
    };
    const onClose = ()=>setOpen(false);
    const onOpenChange = (attrs)=>{
        setOpen(attrs.isOpen);
    };
    const onApprove = (onSuccess, onFailure)=>{
        approveApproval(issueKey, onSuccess, onFailure);
    };
    const onReject = (onSuccess, onFailure)=>{
        rejectApproval(issueKey, onSuccess, onFailure);
    };
    const onTriggerKeyDown = (event)=>{
        // Arrow Up/Down already mapped to table rows and meatball menu trigger should work only on Click
        if (event.key === 'ArrowDown') event.stopPropagation();
    };
    const trigger = ({ triggerRef: triggerRef, isSelected: isSelected, ...triggerProps })=>{
        const iconColor = isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...triggerProps,
            id: issueId.toString(),
            testId: "issue-navigator-issue-operations.ui.button",
            "aria-expanded": isOpen,
            "aria-label": formatMessage((0, $lJU2B.default).menuButtonLabel, {
                issueKey: issueKey
            }),
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                label: "",
                color: iconColor,
                LEGACY_primaryColor: iconColor,
                spacing: "spacious"
            }),
            onClick: onClick,
            ref: triggerRef,
            onKeyDown: onTriggerKeyDown,
            isSelected: isSelected
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rQxZ.DropdownMenuGroupOld), {
        trigger: trigger,
        isOpen: isOpen,
        issueId: issueId,
        issueKey: issueKey,
        workType: workType,
        isCreateSubTaskAllowed: isCreateSubTaskAllowed,
        dataState: state,
        uploadPermissions: uploadPermissions,
        elementToFocusOnClose: `#${issueId}`,
        onIssueRefetch: onRefetch,
        onIssueDelete: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : onDelete,
        onClose: onClose,
        onOpenChange: onOpenChange,
        onAddFlag: onAddFlag,
        onRetry: onRetry,
        onRankToTop: onRankToTop,
        onRankToBottom: onRankToBottom,
        onApprove: onApprove,
        onReject: onReject,
        onIssueDeleteFn: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? onIssueDelete : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null));
};
// TODO: Use Jira flag service instead
const $30107a31e93752a7$var$MeatballMenuWithFlags = (props)=>{
    const [flags, setFlags] = (0, $eJOHy.useState)([]);
    const onAddFlag = (styleClass, isSuccessful)=>setFlags([
            {
                id: flags.length + 1,
                styleClass: styleClass,
                isSuccessful: isSuccessful
            },
            ...flags
        ]);
    const onDismissFlag = ()=>setFlags(flags.slice(1));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            issueId: props.issueId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30107a31e93752a7$export$ef4a0fdddd7eccb7, {
        ...props,
        onAddFlag: onAddFlag
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hAtbw.default), {
        flags: flags,
        onDismiss: onDismissFlag,
        issueKey: props.issueKey
    }));
};
var $30107a31e93752a7$export$2e2bcd8739ae039 = $30107a31e93752a7$var$MeatballMenuWithFlags;

});
parcelRegister("4jUsx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d78953a8dd8b80d4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $d78953a8dd8b80d4$var$useApprovalService = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const approveApproval = (0, $eJOHy.useCallback)(async (issueKey, onSuccess, onFailure)=>{
        try {
            await (0, $3ugTQ.performPostRequest)(`/rest/servicedesk/approvals/1/approval/request/${issueKey}/approve`);
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                type: 'sendOperationalEvent',
                action: 'success',
                actionSubject: 'approveApproval'
            }), 'approveApproval success');
            onSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'approveApproval',
                    packageName: 'jiraIssueNavigatorIssueOperationsServices'
                }
            });
            onFailure();
        }
    }, [
        createAnalyticsEvent
    ]);
    const rejectApproval = (0, $eJOHy.useCallback)(async (issueKey, onSuccess, onFailure)=>{
        try {
            await (0, $3ugTQ.performPostRequest)(`/rest/servicedesk/approvals/1/approval/request/${issueKey}/reject`);
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                type: 'sendOperationalEvent',
                action: 'success',
                actionSubject: 'approveApproval'
            }), 'approveApproval success');
            onSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'approveApproval',
                    packageName: 'jiraIssueNavigatorIssueOperationsServices'
                }
            });
            onFailure();
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        approveApproval: approveApproval,
        rejectApproval: rejectApproval
    };
};
var $d78953a8dd8b80d4$export$2e2bcd8739ae039 = $d78953a8dd8b80d4$var$useApprovalService;

});

parcelRegister("l2S61", function(module, exports) {
$parcel$export(module.exports, "default", () => $289b98c8574924da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4cTDP = parcelRequire("4cTDP");

var $l3YLh = parcelRequire("l3YLh");
const $289b98c8574924da$export$9fc4bf889c7dbfba = ()=>{
    let uploadPermissions;
    let setUploadPermissions;
    if ((0, $4cTDP.fg)('empanada_nin_convert_issue_ops_to_entrypoint')) {
        // eslint-disable-next-line  react-hooks/rules-of-hooks
        const { mediaUploadPermissions: mediaUploadPermissions } = (0, $eJOHy.useContext)((0, $l3YLh.issueOperationsCacheContext));
        [uploadPermissions, setUploadPermissions] = mediaUploadPermissions;
    } else // eslint-disable-next-line  react-hooks/rules-of-hooks
    [uploadPermissions, setUploadPermissions] = (0, $eJOHy.useState)({
        loading: false,
        error: false,
        permissions: null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fetchUploadPermissions = (0, $eJOHy.useCallback)(async (issueId)=>{
        setUploadPermissions((currentState)=>({
                ...currentState,
                loading: true
            }));
        try {
            const uploadResponse = await (0, $hgi0g.default)(`/rest/api/2/attachment/upload/issue/${issueId}/credentials`);
            setUploadPermissions({
                loading: false,
                error: false,
                permissions: {
                    clientId: uploadResponse.clientId,
                    serviceHost: uploadResponse.endpointUrl,
                    token: uploadResponse.token,
                    tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
                    collection: uploadResponse.targetCollection,
                    tokenIssueTimestamp: Date.now() - 10000
                }
            });
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                type: 'sendOperationalEvent',
                action: 'success',
                actionSubject: 'fetchUploadPermissions'
            }), 'fetchUploadPermissions success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'fetchUploadPermissions',
                    packageName: 'jiraIssueNavigatorIssueOperationsServices',
                    teamName: 'empanada'
                }
            });
            setUploadPermissions({
                permissions: null,
                loading: false,
                error: true
            });
        }
    }, [
        createAnalyticsEvent,
        setUploadPermissions
    ]);
    return {
        uploadPermissions: uploadPermissions,
        fetchUploadPermissions: fetchUploadPermissions
    };
};
var $289b98c8574924da$export$2e2bcd8739ae039 = $289b98c8574924da$export$9fc4bf889c7dbfba;

});
parcelRegister("l3YLh", function(module, exports) {
$parcel$export(module.exports, "issueOperationsCacheContext", () => $baa14237616d4ea7$export$95b3204bb3be1344);
$parcel$export(module.exports, "IssueOperationsCacheProvider", () => $baa14237616d4ea7$export$2b992d893f461b1e);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $bJscI = parcelRequire("bJscI");
const $baa14237616d4ea7$var$initialState = {
    operationsAndActions: [
        {
            loading: false,
            loadFieldResources: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        },
        (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    ],
    mediaUploadPermissions: [
        {
            loading: false,
            error: false,
            permissions: null
        },
        (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    ]
};
const $baa14237616d4ea7$export$95b3204bb3be1344 = /*#__PURE__*/ (0, $eJOHy.createContext)($baa14237616d4ea7$var$initialState);
const $baa14237616d4ea7$var$IssueOperationsCacheProviderInner = ({ children: children })=>{
    const [operationsAndActions, setOperationsAndActions] = (0, $eJOHy.useState)($baa14237616d4ea7$var$initialState.operationsAndActions[0]);
    const [mediaUploadPermissions, setMediaUploadPermissions] = (0, $eJOHy.useState)($baa14237616d4ea7$var$initialState.mediaUploadPermissions[0]);
    const value = (0, $eJOHy.useMemo)(()=>({
            operationsAndActions: [
                operationsAndActions,
                setOperationsAndActions
            ],
            mediaUploadPermissions: [
                mediaUploadPermissions,
                setMediaUploadPermissions
            ]
        }), [
        operationsAndActions,
        mediaUploadPermissions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($baa14237616d4ea7$export$95b3204bb3be1344.Provider, {
        value: value
    }, children);
};
const $baa14237616d4ea7$export$2b992d893f461b1e = (0, $bJscI.componentWithFG)('empanada_nin_convert_issue_ops_to_entrypoint', $baa14237616d4ea7$var$IssueOperationsCacheProviderInner, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children));

});


parcelRegister("gguUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f0da805c7db1f8f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $dqd8N = parcelRequire("dqd8N");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $a8PVz = parcelRequire("a8PVz");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $l3YLh = parcelRequire("l3YLh");
const $3f0da805c7db1f8f$var$useOperationsAndActions = ()=>{
    let state;
    let setState;
    if ((0, $4cTDP.fg)('empanada_nin_convert_issue_ops_to_entrypoint')) {
        // eslint-disable-next-line  react-hooks/rules-of-hooks
        const { operationsAndActions: operationsAndActions } = (0, $eJOHy.useContext)((0, $l3YLh.issueOperationsCacheContext));
        [state, setState] = operationsAndActions;
    } else // eslint-disable-next-line  react-hooks/rules-of-hooks
    [state, setState] = (0, $eJOHy.useState)({
        loading: false,
        loadFieldResources: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const toOperation = (issueId, rawOperation)=>{
        const styleAndUrlMap = new Map([
            [
                'com.pyxis.greenhopper.jira:greenhopper-rank-bottom-operation',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).RANK_TO_BOTTOM,
                    url: `/secure/RankBottom.jspa?issueId=${issueId}`
                }
            ],
            [
                'com.pyxis.greenhopper.jira:greenhopper-rank-top-operation',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).RANK_TO_TOP,
                    url: `/secure/RankTop.jspa?issueId=${issueId}`
                }
            ],
            [
                'com.pyxis.greenhopper.jira:greenhopper-rapidboard-operation',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).AGILE_BOARD,
                    url: `/secure/GHGoToBoard.jspa?issueId=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus.cta.createbranch',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).CREATE_BRANCH,
                    url: '#devstatus.cta.createbranch'
                }
            ],
            [
                'com.atlassian.jira.plugins.jira-dnd-attachment-plugin:show-attach-screenshot-popup-button',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ATTACH_SCREENSHOT,
                    url: `/secure/ShowAttachScreenshotFormAction!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugins.jira-dnd-attachment-plugin:unified-attach-file',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ATTACH_FILE,
                    url: `/secure/AttachFile!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugins.jira-admin-helper-plugin:viewissue-notification-trigger-opsbar',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).NOTIFICATION_HELPER,
                    url: '/notimportant'
                }
            ],
            [
                'com.atlassian.jira.plugins.jira-admin-helper-plugin:viewissue-permissionhelper-trigger-opsbar',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).PERMISSION_HELPER,
                    url: '/notimportant'
                }
            ],
            [
                'com.atlassian.jira.plugins.jira-admin-helper-plugin:viewissue-fieldhelper-trigger-opsbar',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).FIELD_HELPER,
                    url: '/notimportant'
                }
            ],
            [
                'com.atlassian.jira.jira-project-config-plugin:add-custom-field',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ADD_FIELD,
                    url: // We definitely do not want an exposure here, its to generate link information the user hasn't seen the option yet
                    (0, $cxKOj.UNSAFE_noExposureExp)('jira-admin-pages-centralised-fields-m1-experiment')?.[0].get('isEnabled', false) ? '/jira/settings/issues/fields' : '/secure/admin/ViewCustomFields.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:delete-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).DELETE,
                    url: `/secure/DeleteIssue!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:edit-labels',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).LABELS,
                    url: `/secure/EditLabels!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:clone-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).CLONE,
                    url: `/secure/CloneIssueDetails!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:link-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).LINK,
                    url: `/secure/LinkJiraIssue!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:move-subtask',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).MOVE_SUBTASK,
                    url: `/secure/MoveSubTaskChooseOperation!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:move-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).MOVE,
                    url: `/secure/MoveIssue!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:issue-to-subtask',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).CONVERT_TO_SUBTASK,
                    url: `/secure/ConvertIssue.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:subtask-to-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).CONVERT_TO_ISSUE,
                    url: `/secure/ConvertSubTask.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:create-subtask',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).CREATE_SUBTASK,
                    url: `/secure/CreateSubTaskIssue!default.jspa?parentIssueId=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:manage-watchers',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).WATCHERS,
                    url: `/secure/ManageWatchers!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:unwatch-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).UNWATCH_ISSUE,
                    url: '/secure/VoteOrWatchIssue.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:watch-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).WATCH_ISSUE,
                    url: '/secure/VoteOrWatchIssue.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:view-voters',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).VIEW_VOTERS,
                    url: `/secure/ViewVoters!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:unvote-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).REMOVE_VOTE,
                    url: '/secure/VoteOrWatchIssue.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:vote-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ADD_VOTE,
                    url: '/secure/VoteOrWatchIssue.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:log-work',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).LOG_WORK,
                    url: `/secure/CreateWorklog!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:comment-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).COMMENT_ISSUE,
                    url: `/secure/AddComment!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:assign-to-me',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ASSIGN_TO_ME,
                    url: '/secure/AssignIssue.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:assign-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ASSIGN,
                    url: '/secure/AssignIssue!default.jspa'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:edit-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).EDIT_ISSUE,
                    url: `/secure/EditIssue!default.jspa?id=${issueId}`
                }
            ],
            [
                'com.atlassian.servicedesk.approvals-plugin:approve-approval',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).APPROVE_APPROVAL,
                    url: '#'
                }
            ],
            [
                'com.atlassian.servicedesk.approvals-plugin:reject-approval',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).REJECT_APPROVAL,
                    url: '#'
                }
            ],
            [
                'com.atlassian.jira.jira-quick-edit-plugin:create-linked-issue-item',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).CREATE_LINKED_ISSUE,
                    url: '#'
                }
            ],
            [
                'com.atlassian.jira.plugin.system.issueoperations:archive-issue',
                {
                    styleClass: (0, $dqd8N.OPERATION_IDS).ARCHIVE,
                    url: '#'
                }
            ]
        ]);
        const styleAndUrlProps = styleAndUrlMap.get(rawOperation.operation);
        if (!styleAndUrlProps) // we could not create a valid operation based on the fetch data
        return undefined;
        return {
            ...rawOperation,
            ...styleAndUrlProps
        };
    };
    const fetchData = (0, $eJOHy.useCallback)(async (issueId)=>{
        setState((currentState)=>({
                ...currentState,
                loading: true
            }));
        try {
            const response = await Promise.all([
                (0, $hgi0g.default)(`/rest/api/1.0/issues/${issueId}/GetActionsAndOperations`),
                (0, $hgi0g.default)(`/rest/viewIssue/1/remoteIssueLink/linkType?issueId=${issueId}`),
                (0, $a8PVz.asyncWrmRequire)([
                    'wrc!com.atlassian.jira.jira-project-config-plugin:custom-fields'
                ]).then(()=>(0, $a8PVz.asyncWrmRequire)([
                        'wrc!com.atlassian.jira.jira-project-config-plugin:custom-fields-impl'
                    ]))
            ]);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window?.JIRA?.Marionette?.Application) {
                // Fill in the missing globals, taken from jira-components/jira-legacy-frontend/jira-issue-search-frontend/jira-global-issue-navigator-frontend/src/main/resources/content/js/Application.js
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const issuesApplication = new window.JIRA.Marionette.Application();
                // Handlers required for Add Field
                issuesApplication.reqres.setHandler('issueEditor:fields', ()=>[]);
                issuesApplication.reqres.setHandler('issueEditor:refreshIssue', ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.AJS.$.Deferred().resolve());
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.JIRA.Issues.Application = issuesApplication;
            }
            const { operations: operationsRaw = [] } = response[0];
            let finalOperations;
            let mappedOperations = [];
            if (operationsRaw.length) mappedOperations = operationsRaw.map((rawOperation)=>{
                // If url and styleCass exist, this is a connect addon operation
                // and we don't need to look up these from the operations map
                if (rawOperation.url && rawOperation.styleClass) return {
                    name: rawOperation.name,
                    styleClass: rawOperation.styleClass,
                    url: rawOperation.url,
                    operation: rawOperation.operation,
                    desc: rawOperation.desc
                };
                // There is no url/styleClass so we need to look these up
                const mappedOperation = toOperation(issueId, rawOperation);
                if (!mappedOperation) (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    action: 'failed',
                    actionSubject: 'getIssueOperationUrl'
                }), 'getIssueOperationUrl failed', {
                    operation: rawOperation.operation
                });
                return mappedOperation;
            })// filter out un-mappable operations
            .filter((operation)=>!!operation);
            // for typecheck: proving mappedOperations after filtering is of the correct type Operation[]
            if ($3f0da805c7db1f8f$export$f31b60e68aa225a8(mappedOperations)) finalOperations = mappedOperations;
            setState({
                data: {
                    actions: response[0].actions ?? [],
                    operations: finalOperations ?? [],
                    links: response[1] ?? []
                },
                loading: false,
                error: false,
                loadFieldResources: (elementToFocusOnClose)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
                    window.require([
                        'jira-project-config/custom-fields/api'
                    ], (api)=>api.addCustomFieldToIssue(issueId, {
                            wizardOptions: {
                                elementToFocusOnClose: elementToFocusOnClose
                            }
                        }))
            });
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                type: 'sendOperationalEvent',
                action: 'success',
                actionSubject: 'fetchOperationsAndFieldsDialog'
            }), 'fetchOperationsAndFieldsDialog success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'fetchOperationsAndCustomFields',
                    packageName: 'jiraIssueNavigatorIssueOperationsServices',
                    teamName: 'empanada'
                }
            });
            setState({
                data: undefined,
                loading: false,
                error: true,
                loadFieldResources: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
            });
        }
    }, [
        createAnalyticsEvent,
        setState
    ]);
    const cleanUpState = ()=>setState({
            loading: false,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            loadFieldResources: ()=>{}
        });
    return {
        fetchData: fetchData,
        state: state,
        cleanUpState: cleanUpState
    };
};
function $3f0da805c7db1f8f$export$f31b60e68aa225a8(list = []) {
    return list.every((item)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        typeof item.operation === 'string' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        typeof item.name === 'string' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        typeof item.url === 'string' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        typeof item.styleClass === 'string');
}
var $3f0da805c7db1f8f$export$2e2bcd8739ae039 = $3f0da805c7db1f8f$var$useOperationsAndActions;

});
parcelRegister("dqd8N", function(module, exports) {
$parcel$export(module.exports, "APPROVE_APPROVAL", () => $4606e370dcf52bcf$export$930b4cd4976c0a5e);
$parcel$export(module.exports, "REJECT_APPROVAL", () => $4606e370dcf52bcf$export$7be4d39b1a8b321a);
$parcel$export(module.exports, "OPERATION_IDS", () => $4606e370dcf52bcf$export$498178c427a35252);
$parcel$export(module.exports, "LINK_IDS", () => $4606e370dcf52bcf$export$1fff534c17344ccf);
$parcel$export(module.exports, "DIALOG_FIELDS", () => $4606e370dcf52bcf$export$5ae74c325a8e870e);
$parcel$export(module.exports, "SKIP_FIELDS_OLD", () => $4606e370dcf52bcf$export$e4c60e424c6192ef);
$parcel$export(module.exports, "SKIP_FIELDS_NEW", () => $4606e370dcf52bcf$export$47a735d68d3bb0eb);
$parcel$export(module.exports, "SKIP_FIELDS_ATTACH_FILE", () => $4606e370dcf52bcf$export$f1f0803724891978);
$parcel$export(module.exports, "URL_OVERRIDE_FIELDS", () => $4606e370dcf52bcf$export$b86499b7cf24c281);
$parcel$export(module.exports, "DIALOG_DATA", () => $4606e370dcf52bcf$export$f57e70208d0fb8b9);
const $4606e370dcf52bcf$var$VIEW_ISSUE = 'issueaction-view-issue';
const $4606e370dcf52bcf$var$EDIT_ISSUE = 'issueaction-edit-issue';
const $4606e370dcf52bcf$var$ASSIGN = 'issueaction-assign-issue';
const $4606e370dcf52bcf$var$ASSIGN_TO_ME = 'issueaction-assign-to-me hide-from-opsbar';
const $4606e370dcf52bcf$var$COMMENT_ISSUE = 'issueaction-comment-issue add-issue-comment';
const $4606e370dcf52bcf$var$LOG_WORK = 'issueaction-log-work';
const $4606e370dcf52bcf$var$AGILE_BOARD = 'issueaction-greenhopper-rapidboard-operation js-rapidboard-operation-issue';
const $4606e370dcf52bcf$var$RANK_TO_TOP = 'issueaction-greenhopper-rank-top-operation';
const $4606e370dcf52bcf$var$RANK_TO_BOTTOM = 'issueaction-greenhopper-rank-bottom-operation';
const $4606e370dcf52bcf$var$ATTACH_FILE = 'unified-attach-file';
const $4606e370dcf52bcf$var$ATTACH_SCREENSHOT = 'issueaction-attach-screenshot-html5';
const $4606e370dcf52bcf$var$ADD_VOTE = 'issueaction-vote-issue';
const $4606e370dcf52bcf$var$REMOVE_VOTE = 'issueaction-unvote-issue';
const $4606e370dcf52bcf$var$VIEW_VOTERS = 'issueaction-view-voters';
const $4606e370dcf52bcf$var$WATCH_ISSUE = 'issueaction-watch-issue';
const $4606e370dcf52bcf$var$UNWATCH_ISSUE = 'issueaction-unwatch-issue';
const $4606e370dcf52bcf$var$WATCHERS = 'issueaction-manage-watchers';
const $4606e370dcf52bcf$var$CREATE_SUBTASK = 'issueaction-create-subtask';
const $4606e370dcf52bcf$var$CONVERT_TO_ISSUE = 'issueaction-subtask-to-issue';
const $4606e370dcf52bcf$var$CONVERT_TO_SUBTASK = 'issueaction-issue-to-subtask';
const $4606e370dcf52bcf$var$CREATE_BRANCH = 'devstatus-cta-link';
const $4606e370dcf52bcf$var$CREATE_LINKED_ISSUE = 'issueaction-create-linked-issue';
const $4606e370dcf52bcf$var$MOVE = 'issueaction-move-issue';
const $4606e370dcf52bcf$var$MOVE_SUBTASK = 'issueaction-move-subtask';
const $4606e370dcf52bcf$var$LINK = 'issueaction-link-issue';
const $4606e370dcf52bcf$var$CLONE = 'issueaction-clone-issue';
const $4606e370dcf52bcf$var$LABELS = 'issueaction-edit-labels';
const $4606e370dcf52bcf$var$ARCHIVE = 'issueaction-archive-issue';
const $4606e370dcf52bcf$var$DELETE = 'issueaction-delete-issue';
const $4606e370dcf52bcf$var$ADD_FIELD = 'issueaction-fields-add';
const $4606e370dcf52bcf$var$PERMISSION_HELPER = 'permissionhelper-trigger';
const $4606e370dcf52bcf$var$NOTIFICATION_HELPER = 'notificationhelper-trigger';
const $4606e370dcf52bcf$var$FIELD_HELPER = 'whereismycf-trigger';
const $4606e370dcf52bcf$var$LINK_ISSUE = 'add-jira-issue-link-link';
const $4606e370dcf52bcf$var$LINK_CONFLUENCE_PAGE = 'add-confluence-page-link-link';
const $4606e370dcf52bcf$var$ADD_WEB_LINK = 'add-web-link-link';
const $4606e370dcf52bcf$export$930b4cd4976c0a5e = 'js-issueaction-approve-approval';
const $4606e370dcf52bcf$export$7be4d39b1a8b321a = 'js-issueaction-reject-approval';
const $4606e370dcf52bcf$export$498178c427a35252 = {
    VIEW_ISSUE: $4606e370dcf52bcf$var$VIEW_ISSUE,
    EDIT_ISSUE: $4606e370dcf52bcf$var$EDIT_ISSUE,
    ASSIGN: $4606e370dcf52bcf$var$ASSIGN,
    ASSIGN_TO_ME: $4606e370dcf52bcf$var$ASSIGN_TO_ME,
    COMMENT_ISSUE: $4606e370dcf52bcf$var$COMMENT_ISSUE,
    LOG_WORK: $4606e370dcf52bcf$var$LOG_WORK,
    AGILE_BOARD: $4606e370dcf52bcf$var$AGILE_BOARD,
    RANK_TO_TOP: $4606e370dcf52bcf$var$RANK_TO_TOP,
    RANK_TO_BOTTOM: $4606e370dcf52bcf$var$RANK_TO_BOTTOM,
    ATTACH_FILE: $4606e370dcf52bcf$var$ATTACH_FILE,
    ATTACH_SCREENSHOT: $4606e370dcf52bcf$var$ATTACH_SCREENSHOT,
    ADD_VOTE: $4606e370dcf52bcf$var$ADD_VOTE,
    REMOVE_VOTE: $4606e370dcf52bcf$var$REMOVE_VOTE,
    VIEW_VOTERS: $4606e370dcf52bcf$var$VIEW_VOTERS,
    WATCH_ISSUE: $4606e370dcf52bcf$var$WATCH_ISSUE,
    UNWATCH_ISSUE: $4606e370dcf52bcf$var$UNWATCH_ISSUE,
    WATCHERS: $4606e370dcf52bcf$var$WATCHERS,
    CREATE_SUBTASK: $4606e370dcf52bcf$var$CREATE_SUBTASK,
    CONVERT_TO_ISSUE: $4606e370dcf52bcf$var$CONVERT_TO_ISSUE,
    CONVERT_TO_SUBTASK: $4606e370dcf52bcf$var$CONVERT_TO_SUBTASK,
    CREATE_BRANCH: $4606e370dcf52bcf$var$CREATE_BRANCH,
    CREATE_LINKED_ISSUE: $4606e370dcf52bcf$var$CREATE_LINKED_ISSUE,
    MOVE: $4606e370dcf52bcf$var$MOVE,
    MOVE_SUBTASK: $4606e370dcf52bcf$var$MOVE_SUBTASK,
    LINK: $4606e370dcf52bcf$var$LINK,
    CLONE: $4606e370dcf52bcf$var$CLONE,
    LABELS: $4606e370dcf52bcf$var$LABELS,
    ARCHIVE: $4606e370dcf52bcf$var$ARCHIVE,
    DELETE: $4606e370dcf52bcf$var$DELETE,
    ADD_FIELD: $4606e370dcf52bcf$var$ADD_FIELD,
    PERMISSION_HELPER: $4606e370dcf52bcf$var$PERMISSION_HELPER,
    NOTIFICATION_HELPER: $4606e370dcf52bcf$var$NOTIFICATION_HELPER,
    FIELD_HELPER: $4606e370dcf52bcf$var$FIELD_HELPER,
    LINK_ISSUE: $4606e370dcf52bcf$var$LINK_ISSUE,
    LINK_CONFLUENCE_PAGE: $4606e370dcf52bcf$var$LINK_CONFLUENCE_PAGE,
    ADD_WEB_LINK: $4606e370dcf52bcf$var$ADD_WEB_LINK,
    APPROVE_APPROVAL: $4606e370dcf52bcf$export$930b4cd4976c0a5e,
    REJECT_APPROVAL: $4606e370dcf52bcf$export$7be4d39b1a8b321a
};
const $4606e370dcf52bcf$export$1fff534c17344ccf = {
    LINK_ISSUE: $4606e370dcf52bcf$var$LINK_ISSUE,
    LINK_CONFLUENCE_PAGE: $4606e370dcf52bcf$var$LINK_CONFLUENCE_PAGE,
    ADD_WEB_LINK: $4606e370dcf52bcf$var$ADD_WEB_LINK
};
const $4606e370dcf52bcf$export$5ae74c325a8e870e = [
    $4606e370dcf52bcf$var$EDIT_ISSUE,
    $4606e370dcf52bcf$var$COMMENT_ISSUE,
    $4606e370dcf52bcf$var$LOG_WORK,
    $4606e370dcf52bcf$var$RANK_TO_TOP,
    $4606e370dcf52bcf$var$RANK_TO_BOTTOM,
    $4606e370dcf52bcf$var$ATTACH_FILE,
    $4606e370dcf52bcf$var$ADD_VOTE,
    $4606e370dcf52bcf$var$REMOVE_VOTE,
    $4606e370dcf52bcf$var$WATCH_ISSUE,
    $4606e370dcf52bcf$var$UNWATCH_ISSUE,
    $4606e370dcf52bcf$var$LINK,
    $4606e370dcf52bcf$var$CLONE,
    $4606e370dcf52bcf$var$LABELS,
    $4606e370dcf52bcf$var$ARCHIVE,
    $4606e370dcf52bcf$var$DELETE,
    $4606e370dcf52bcf$var$ADD_FIELD,
    $4606e370dcf52bcf$var$PERMISSION_HELPER,
    $4606e370dcf52bcf$var$NOTIFICATION_HELPER,
    $4606e370dcf52bcf$var$ASSIGN,
    $4606e370dcf52bcf$var$ASSIGN_TO_ME,
    $4606e370dcf52bcf$var$ATTACH_SCREENSHOT,
    $4606e370dcf52bcf$var$CREATE_LINKED_ISSUE,
    $4606e370dcf52bcf$var$CREATE_SUBTASK
];
const $4606e370dcf52bcf$export$e4c60e424c6192ef = [
    $4606e370dcf52bcf$var$EDIT_ISSUE,
    $4606e370dcf52bcf$var$ASSIGN,
    $4606e370dcf52bcf$var$ASSIGN_TO_ME,
    $4606e370dcf52bcf$var$ATTACH_SCREENSHOT,
    $4606e370dcf52bcf$var$CREATE_LINKED_ISSUE,
    $4606e370dcf52bcf$var$CREATE_BRANCH,
    $4606e370dcf52bcf$var$LINK,
    $4606e370dcf52bcf$var$LINK_ISSUE,
    $4606e370dcf52bcf$var$LINK_CONFLUENCE_PAGE
];
const $4606e370dcf52bcf$export$47a735d68d3bb0eb = [
    $4606e370dcf52bcf$var$EDIT_ISSUE,
    $4606e370dcf52bcf$var$ASSIGN,
    $4606e370dcf52bcf$var$ASSIGN_TO_ME,
    $4606e370dcf52bcf$var$ATTACH_SCREENSHOT,
    $4606e370dcf52bcf$var$CREATE_LINKED_ISSUE,
    $4606e370dcf52bcf$var$CREATE_BRANCH,
    $4606e370dcf52bcf$var$LINK,
    $4606e370dcf52bcf$var$LINK_CONFLUENCE_PAGE
];
const $4606e370dcf52bcf$export$f1f0803724891978 = [
    $4606e370dcf52bcf$var$ATTACH_FILE
];
const $4606e370dcf52bcf$export$b86499b7cf24c281 = {
    [$4606e370dcf52bcf$var$PERMISSION_HELPER]: '/secure/admin/PermissionHelperAdmin.jspa',
    [$4606e370dcf52bcf$var$NOTIFICATION_HELPER]: '/secure/admin/NotificationHelperAdmin.jspa'
};
const $4606e370dcf52bcf$export$f57e70208d0fb8b9 = {
    [$4606e370dcf52bcf$var$ASSIGN]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$4606e370dcf52bcf$var$ASSIGN_TO_ME]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$4606e370dcf52bcf$var$COMMENT_ISSUE]: {
        id: 'comment-add-dialog',
        issueMsg: 'thanksIssueCommented'
    },
    [$4606e370dcf52bcf$var$ATTACH_FILE]: {
        id: 'attach-file-dialog',
        issueMsg: 'thanksIssueAttached'
    },
    [$4606e370dcf52bcf$var$DELETE]: {
        id: 'delete-issue-dialog',
        issueMsg: 'thanksIssueDeleted'
    },
    [$4606e370dcf52bcf$var$CLONE]: {
        id: 'clone-issue-dialog',
        issueMsg: 'thanksIssueCloned'
    },
    [$4606e370dcf52bcf$var$LOG_WORK]: {
        id: 'edit-log-work-dialog',
        issueMsg: 'thanksIssueWorklogged'
    },
    [$4606e370dcf52bcf$var$LABELS]: {
        id: 'edit-labels-dialog',
        issueMsg: 'thanksIssueLabelled'
    }
};

});


parcelRegister("b1GOu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d334314b6d2ca47$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $6d334314b6d2ca47$var$useIssueRankService = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const rankToTopQuery = (0, $eJOHy.useCallback)(async (issueId, onSuccess, onFailure)=>{
        try {
            await (0, $3ugTQ.performPostRequest)('/rest/greenhopper/1.0/rank/global/first', {
                body: JSON.stringify({
                    issueId: issueId
                })
            });
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                type: 'sendOperationalEvent',
                action: 'success',
                actionSubject: 'rankToTopQuery'
            }), 'rankToTopQuery success');
            onSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'rankToTopQuery',
                    packageName: 'jiraIssueNavigatorIssueOperationsServices',
                    teamName: 'empanada'
                }
            });
            onFailure();
        }
    }, [
        createAnalyticsEvent
    ]);
    const rankToBottomQuery = (0, $eJOHy.useCallback)(async (issueId, onSuccess, onFailure)=>{
        try {
            await (0, $3ugTQ.performPostRequest)('/rest/greenhopper/1.0/rank/global/last', {
                body: JSON.stringify({
                    issueId: issueId
                })
            });
            (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({
                type: 'sendOperationalEvent',
                action: 'success',
                actionSubject: 'rankToBottomQuery'
            }), 'rankToBottomQuery success');
            onSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: e,
                meta: {
                    id: 'rankToBottomQuery',
                    packageName: 'jiraIssueNavigatorIssueOperationsServices',
                    teamName: 'empanada'
                }
            });
            onFailure();
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        rankToTopQuery: rankToTopQuery,
        rankToBottomQuery: rankToBottomQuery
    };
};
var $6d334314b6d2ca47$export$2e2bcd8739ae039 = $6d334314b6d2ca47$var$useIssueRankService;

});

parcelRegister("2rQxZ", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuGroupNew", () => $045aea988a297897$export$943c9e4544592d31);
$parcel$export(module.exports, "DropdownMenuGroupOld", () => $045aea988a297897$export$26f0d19da5e1dc9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $7rjYb = parcelRequire("7rjYb");
var $aLJ1L = parcelRequire("aLJ1L");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $dqd8N = parcelRequire("dqd8N");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $gCY1z = parcelRequire("gCY1z");

var $cxKOj = parcelRequire("cxKOj");

var $anrJM = parcelRequire("anrJM");

var $KKEkl = parcelRequire("KKEkl");

var $am4Zv = parcelRequire("am4Zv");

var $e5bJV = parcelRequire("e5bJV");

var $b6Ade = parcelRequire("b6Ade");

var $3UGvB = parcelRequire("3UGvB");
const $045aea988a297897$var$isUrlOverrideFieldClass = (className)=>Object.keys((0, $dqd8N.URL_OVERRIDE_FIELDS)).includes(className);
const $045aea988a297897$var$getDialogFields = ()=>[
        ...(0, $dqd8N.DIALOG_FIELDS),
        (0, $dqd8N.APPROVE_APPROVAL),
        (0, $dqd8N.REJECT_APPROVAL)
    ];
const $045aea988a297897$var$mapOperationToActionItem = ({ name: name, url: givenUrl, styleClass: field })=>{
    const url = $045aea988a297897$var$isUrlOverrideFieldClass(field) ? (0, $dqd8N.URL_OVERRIDE_FIELDS)[field] : givenUrl;
    return {
        name: name,
        url: url,
        field: field
    };
};
const $045aea988a297897$var$linksNeedToSkip = ({ id: id })=>(0, $4cTDP.fg)('nin_add_link_issue_to_issue_operations') ? !(0, $dqd8N.SKIP_FIELDS_NEW).includes(id) : !(0, $dqd8N.SKIP_FIELDS_OLD).includes(id);
const $045aea988a297897$export$943c9e4544592d31 = ({ issueId: issueId, dataState: dataState, uploadPermissions: uploadPermissions, isCreateSubTaskAllowed: isCreateSubTaskAllowed, workType: workType, onIssueDeleteFn: onIssueDeleteFn, onIssueDelete: onIssueDelete, ...props })=>{
    const { issueKey: issueKey } = props;
    const { data: data, loadFieldResources: loadFieldResources } = dataState;
    const { permissions: permissions, error: permissionsError } = uploadPermissions;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ route: route }] = (0, $gCY1z.useRouter)();
    const isServiceDeskList = route?.name === 'servicedesk-list';
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)((fieldType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'field'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'meatballField', {
            fieldType: fieldType
        });
    }, [
        createAnalyticsEvent
    ]);
    const skipFields = (0, $4cTDP.fg)('nin_add_link_issue_to_issue_operations') ? (0, $dqd8N.SKIP_FIELDS_NEW) : (0, $dqd8N.SKIP_FIELDS_OLD);
    const operationsNeedToSkip = (0, $eJOHy.useCallback)(({ styleClass: field })=>!skipFields.includes(field) && !(field === (0, $dqd8N.OPERATION_IDS).ATTACH_FILE && permissionsError) && !(field === (0, $dqd8N.OPERATION_IDS).CREATE_SUBTASK && !isCreateSubTaskAllowed), [
        isCreateSubTaskAllowed,
        permissionsError,
        skipFields
    ]);
    const isIssueArchivalEnabled = (0, $4cTDP.fg)('issue_deletion_two_step_process_free_standard') && data?.operations?.filter(operationsNeedToSkip).map($045aea988a297897$var$mapOperationToActionItem).some(({ field: field })=>field !== null && field === (0, $dqd8N.OPERATION_IDS).ARCHIVE);
    const createButtonItem = (name, url, field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
            key: field
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5bJV.DropdownButtonItem), {
            issueId: issueId,
            url: url,
            workType: workType,
            name: name,
            styleClass: field,
            onAddFieldClick: loadFieldResources,
            uploadPermissions: permissions,
            onFireAnalyticsEvent: fireAnalyticsEvent,
            isIssueArchivalEnabled: isIssueArchivalEnabled,
            onAddFlag: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onIssueDelete: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : onIssueDelete,
            onIssueDeleteFn: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? onIssueDeleteFn : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            ...props
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$DropdownMenuHeight, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        testId: "issue-navigator-issue-operations.ui.dropdown-menu-group.menu-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$List, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, null, isServiceDeskList && (0, $4cTDP.fg)('jsm_list_view_milestone_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItem), {
        key: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        href: `/browse/${issueKey}`,
        target: "_blank",
        onClick: ()=>fireAnalyticsEvent((0, $dqd8N.OPERATION_IDS).VIEW_ISSUE),
        params: {
            issueKey: issueKey
        },
        menuItemId: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        actionSubjectId: "issueOperationsMeatballMenu"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $b6Ade.default).viewIssueLabelIssueTerminologyRefreshM4 : (0, $b6Ade.default).viewIssueLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItem), {
        key: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        href: `/browse/${issueKey}`,
        onClick: ()=>fireAnalyticsEvent((0, $dqd8N.OPERATION_IDS).VIEW_ISSUE),
        params: {
            issueKey: issueKey
        },
        menuItemId: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        actionSubjectId: "issueOperationsMeatballMenu"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $b6Ade.default).viewIssueLabelIssueTerminologyRefreshM4 : (0, $b6Ade.default).viewIssueLabel))), data?.operations?.filter(operationsNeedToSkip).map($045aea988a297897$var$mapOperationToActionItem).map(({ name: name, url: url, field: field })=>{
        const dialogFields = $045aea988a297897$var$getDialogFields();
        if (dialogFields.includes(field)) {
            if (field === (0, $dqd8N.OPERATION_IDS).ATTACH_FILE && (0, $4cTDP.fg)('empanada_nin_convert_issue_ops_to_entrypoint')) {
                // Only render if we have valid permissions data
                if (!permissions) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
                    key: field
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $anrJM.ModalDropdownItemTrigger), {
                    entryPoint: (0, $KKEkl.attachFileDialogEntryPoint),
                    entryPointProps: {
                        issueId: issueId,
                        issueKey: issueKey,
                        workType: workType,
                        mediaUploadContext: permissions
                    },
                    onClick: ()=>fireAnalyticsEvent(field),
                    testId: "issue-navigator-issue-operations.ui.dropdown-menu-group.attach-file-modal-trigger"
                }, name));
            }
            return createButtonItem(name, url, field);
        }
        return (0, $4cTDP.fg)('nin_trigger_connect_webitem_dialog') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
            key: field
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItem), {
            href: url,
            onClick: ()=>fireAnalyticsEvent(field),
            styleClass: field,
            name: name,
            menuItemId: name,
            actionSubjectId: "issueOperationsMeatballMenu"
        }, name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
            key: field
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItemOld), {
            href: url,
            onClick: ()=>fireAnalyticsEvent(field),
            styleClass: field,
            name: name
        }, name));
    }), data?.links?.filter($045aea988a297897$var$linksNeedToSkip).map(({ id: id, url: url, label: label })=>createButtonItem(label, url, id)))));
};
const $045aea988a297897$export$26f0d19da5e1dc9 = ({ issueId: issueId, isOpen: isOpen, placement: placement, trigger: trigger, dataState: dataState, onClose: onClose, onOpenChange: onOpenChange, onRetry: onRetry, uploadPermissions: uploadPermissions, testId: testId, isCreateSubTaskAllowed: isCreateSubTaskAllowed, workType: workType, onIssueDeleteFn: onIssueDeleteFn, onIssueDelete: onIssueDelete, ...props })=>{
    const { issueKey: issueKey } = props;
    const { data: data, error: error, loading: operationsLoading, loadFieldResources: loadFieldResources } = dataState;
    const { permissions: permissions, loading: permissionsLoading, error: permissionsError } = uploadPermissions;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ route: route }] = (0, $gCY1z.useRouter)();
    const isServiceDeskList = route?.name === 'servicedesk-list';
    const fireAnalyticsEvent = (0, $eJOHy.useCallback)((fieldType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'field'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'meatballField', {
            fieldType: fieldType
        });
    }, [
        createAnalyticsEvent
    ]);
    const skipFields = (0, $4cTDP.fg)('nin_add_link_issue_to_issue_operations') ? (0, $dqd8N.SKIP_FIELDS_NEW) : (0, $dqd8N.SKIP_FIELDS_OLD);
    const operationsNeedToSkip = (0, $eJOHy.useCallback)(({ styleClass: field })=>!skipFields.includes(field) && !(field === (0, $dqd8N.OPERATION_IDS).ATTACH_FILE && permissionsError) && !(field === (0, $dqd8N.OPERATION_IDS).CREATE_SUBTASK && !isCreateSubTaskAllowed), [
        isCreateSubTaskAllowed,
        permissionsError,
        skipFields
    ]);
    const isIssueArchivalEnabled = (0, $4cTDP.fg)('issue_deletion_two_step_process_free_standard') && data?.operations?.filter(operationsNeedToSkip).map($045aea988a297897$var$mapOperationToActionItem).some(({ field: field })=>field !== null && field === (0, $dqd8N.OPERATION_IDS).ARCHIVE);
    const createButtonItem = (0, $eJOHy.useCallback)((name, url, field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
            key: field
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5bJV.DropdownButtonItem), {
            issueId: issueId,
            url: url,
            workType: workType,
            name: name,
            styleClass: field,
            onAddFieldClick: loadFieldResources,
            onClose: onClose,
            uploadPermissions: permissions,
            onFireAnalyticsEvent: fireAnalyticsEvent,
            isIssueArchivalEnabled: isIssueArchivalEnabled,
            onIssueDelete: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : onIssueDelete,
            onIssueDeleteFn: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? onIssueDeleteFn : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            ...props
        })), [
        fireAnalyticsEvent,
        isIssueArchivalEnabled,
        issueId,
        loadFieldResources,
        onClose,
        onIssueDelete,
        onIssueDeleteFn,
        permissions,
        props,
        workType
    ]);
    const createLinkItemNew = (0, $eJOHy.useCallback)((name, url, field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
            key: field
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItem), {
            href: url,
            onClick: ()=>fireAnalyticsEvent(field),
            styleClass: field,
            name: name,
            menuItemId: name,
            actionSubjectId: "issueOperationsMeatballMenu"
        }, name)), [
        fireAnalyticsEvent
    ]);
    const createLinkItemOld = (0, $eJOHy.useCallback)((name, url, field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, {
            key: field
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItemOld), {
            href: url,
            onClick: ()=>fireAnalyticsEvent(field),
            styleClass: field,
            name: name
        }, name)), [
        fireAnalyticsEvent
    ]);
    const dropdownMenuProps = {
        isOpen: isOpen,
        placement: 'bottom-end',
        shouldRenderToParent: true,
        trigger: trigger,
        onOpenChange: onOpenChange,
        testId: testId,
        isLoading: operationsLoading || permissionsLoading
    };
    if (error ?? false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        ...dropdownMenuProps,
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $am4Zv.ErrorState), {
        onRetry: onRetry
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        ...dropdownMenuProps,
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$DropdownMenuHeight, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        testId: "issue-navigator-issue-operations.ui.dropdown-menu-group.menu-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$List, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($045aea988a297897$var$ListItem, null, isServiceDeskList && (0, $4cTDP.fg)('jsm_list_view_milestone_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItem), {
        key: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        href: `/browse/${issueKey}`,
        target: "_blank",
        onClick: ()=>fireAnalyticsEvent((0, $dqd8N.OPERATION_IDS).VIEW_ISSUE),
        params: {
            issueKey: issueKey
        },
        menuItemId: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        actionSubjectId: "issueOperationsMeatballMenu"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $b6Ade.default).viewIssueLabelIssueTerminologyRefreshM4 : (0, $b6Ade.default).viewIssueLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3UGvB.RouteLinkItem), {
        key: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        href: `/browse/${issueKey}`,
        onClick: ()=>fireAnalyticsEvent((0, $dqd8N.OPERATION_IDS).VIEW_ISSUE),
        params: {
            issueKey: issueKey
        },
        menuItemId: (0, $dqd8N.OPERATION_IDS).VIEW_ISSUE,
        actionSubjectId: "issueOperationsMeatballMenu"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $b6Ade.default).viewIssueLabelIssueTerminologyRefreshM4 : (0, $b6Ade.default).viewIssueLabel))), data?.operations?.filter(operationsNeedToSkip).map($045aea988a297897$var$mapOperationToActionItem).map(({ name: name, url: url, field: field })=>{
        const dialogFields = $045aea988a297897$var$getDialogFields();
        if (dialogFields.includes(field)) return createButtonItem(name, url, field);
        return (0, $4cTDP.fg)('nin_trigger_connect_webitem_dialog') ? createLinkItemNew(name, url, field) : createLinkItemOld(name, url, field);
    }), data?.links?.filter($045aea988a297897$var$linksNeedToSkip).map(({ id: id, url: url, label: label })=>createButtonItem(label, url, id))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $045aea988a297897$var$List = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $045aea988a297897$var$ListItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
            __cmplp.className
        ])
    });
}); /**
     * Work around for https://product-fabric.atlassian.net/browse/DSP-7932
     */ 
const $045aea988a297897$var$DropdownMenuHeight = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71leo28 _1ul9p3fh _p12fp3fh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("anrJM", function(module, exports) {
$parcel$export(module.exports, "ModalDropdownItemTrigger", () => $bd8c6437850e43b0$export$d24aab363378eba0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $asoyU = parcelRequire("asoyU");
const $bd8c6437850e43b0$export$d24aab363378eba0 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, preloadOnFocus: preloadOnFocus, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asoyU.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        preloadOnFocus: preloadOnFocus,
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                ref: ref,
                ...dropdownProps,
                children: children
            })
    });
};

});

parcelRegister("KKEkl", function(module, exports) {
$parcel$export(module.exports, "attachFileDialogEntryPoint", () => $1e61b2c1005334d6$export$b335b21a19877ed0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $1e61b2c1005334d6$export$b335b21a19877ed0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fIz5X")), {
        moduleId: "cf54b534",
        moduleName: "AttachFileDialogNew",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fIz5X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jBidU").then(()=>parcelRequire('eRBH7'));

});


parcelRegister("e5bJV", function(module, exports) {
$parcel$export(module.exports, "DropdownButtonItem", () => $2b56ad49f4d71834$export$37946c7734078e9);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $jYYbf = parcelRequire("jYYbf");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $7BKle = parcelRequire("7BKle");

var $1jlQo = parcelRequire("1jlQo");

var $eVOjw = parcelRequire("eVOjw");

var $dqd8N = parcelRequire("dqd8N");

var $cTddL = parcelRequire("cTddL");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $ftN6c = parcelRequire("ftN6c");

var $e6YEs = parcelRequire("e6YEs");

var $cxKOj = parcelRequire("cxKOj");

var $9bIo2 = parcelRequire("9bIo2");

var $iPZU8 = parcelRequire("iPZU8");

var $hAtbw = parcelRequire("hAtbw");

var $eQfx2 = parcelRequire("eQfx2");
const $2b56ad49f4d71834$export$37946c7734078e9 = ({ name: name, url: url, styleClass: styleClass, onAddFlag: onAddFlagOld, onIssueRefetch: onIssueRefetch, onIssueDelete: onIssueDelete, onIssueDeleteFn: onIssueDeleteFn, onRankToTop: onRankToTop, onRankToBottom: onRankToBottom, onApprove: onApprove, onReject: onReject, onAddFieldClick: onAddFieldClick, issueId: issueId, issueKey: issueKey, workType: workType, onClose: onClose, uploadPermissions: uploadPermissions, onFireAnalyticsEvent: onFireAnalyticsEvent, elementToFocusOnClose: elementToFocusOnClose, isIssueArchivalEnabled: isIssueArchivalEnabled })=>{
    const onIssueDeleteNew = (0, $eJOHy.useCallback)(()=>{
        (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? onIssueDeleteFn?.(issueKey) : onIssueDelete();
    }, [
        issueKey,
        onIssueDelete,
        onIssueDeleteFn
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { setDialogContext: setDialogContext }] = (0, $cTddL.useIssueOperationsDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const accountId = (0, $e6YEs.useAccountId)();
    const deleteIssue = (0, $iPZU8.useDeleteIssue)();
    const onAddFlagNew = (0, $hAtbw.useIssueOperationFlags)(issueKey);
    const onAddFlag = (0, $4cTDP.fg)('empanada_nin_convert_issue_ops_to_entrypoint') ? onAddFlagNew : onAddFlagOld;
    const onSuccess = (0, $eJOHy.useCallback)(()=>{
        (0, $eVOjw.fireSuccessAnalytics)(analyticsEvent, styleClass);
        styleClass === (0, $dqd8N.OPERATION_IDS).DELETE ? onIssueDeleteNew() : onIssueRefetch();
        onAddFlag(styleClass, true);
    }, [
        analyticsEvent,
        onAddFlag,
        onIssueDeleteNew,
        onIssueRefetch,
        styleClass
    ]);
    const onFailure = (0, $eJOHy.useCallback)(()=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'performIssueOperation',
                packageName: 'jiraIssueNavigatorIssueOperations',
                teamName: 'empanada'
            },
            attributes: {
                operation: styleClass
            }
        });
        onAddFlag(styleClass, false);
    }, [
        onAddFlag,
        styleClass
    ]);
    const loadDefaultDialog = ()=>(0, $eVOjw.loadDialog)({
            styleClass: styleClass,
            url: url,
            onSuccess: onSuccess,
            onFailure: onFailure,
            issueId: issueId,
            accountId: accountId,
            elementToFocusOnClose: elementToFocusOnClose
        });
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const onClickOpenCreateSubTaskIssueDialog = ()=>{
        if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.IssueCreate?.Visibility?.isEnabled && (0, $4cTDP.fg)('render_modern_global_issue_create_modal_experience')) {
            const parentIssueId = issueId?.toString() || '';
            openIssueCreateModal({
                isSubTaskCreationOpen: true,
                payload: {
                    // this allows to pre-populate the parent field when creating a sub-task from a level 0 issue
                    defaultValues: {
                        parentField: {
                            issueId: parentIssueId
                        }
                    },
                    parentId: {
                        parentId: parentIssueId
                    }
                },
                onIssueCreate: onIssueRefetch,
                triggerPointKey: (0, $84DOT.CREATE_SUBTASK_NIN_TRIGGER)
            });
        } else (0, $eVOjw.openCreateSubTaskIssueDialog)({
            onDismissAfterCreate: ()=>{
                onIssueRefetch();
                onAddFlag((0, $dqd8N.OPERATION_IDS).CREATE_SUBTASK, true);
            }
        });
    };
    const { openArchiveIssueModal: openArchiveIssueModal } = (0, $1jlQo.useArchiveIssueModalActions)();
    const onIssueArchiveSuccess = ()=>{
        onIssueDeleteNew();
    };
    const onClickOpenIssueArchiveModal = ()=>{
        const issueIdArg = issueId?.toString();
        openArchiveIssueModal({
            issueKey: issueKey,
            issueId: issueIdArg,
            onIssueArchiveSuccess: onIssueArchiveSuccess,
            triggerPointKey: (0, $7BKle.TRIGGER_POINT_KEY_ISSUE_NAVIGATOR),
            workType: workType || '',
            onDeleteIssuesFromNINView: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? onIssueDeleteFn : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        });
    };
    const { openDeleteIssueModal: openDeleteIssueModal, closeDeleteIssueModal: closeDeleteIssueModal, startDeleteIssue: startDeleteIssue, endDeleteIssue: endDeleteIssue } = (0, $9bIo2.useDeleteIssueModalActions)();
    const onTriggerDeleteRequest = ()=>{
        try {
            startDeleteIssue();
            deleteIssue({
                issueKey: issueKey
            });
            endDeleteIssue({
                didIssueDeleteFail: false
            });
            onSuccess();
        } catch (error) {
            endDeleteIssue({
                didIssueDeleteFail: true
            });
            onFailure();
        }
        closeDeleteIssueModal();
    };
    const onClickOpenIssueDeleteModal = ()=>{
        openDeleteIssueModal({
            isIssueArchivalEnabled: isIssueArchivalEnabled || false,
            workType: workType,
            issueKey: issueKey,
            issueId: issueId?.toString(),
            onTriggerDeleteRequest: onTriggerDeleteRequest,
            onIssueDeleteSuccess: onSuccess,
            onIssueDeleteFailure: onFailure
        });
    };
    let onClick = loadDefaultDialog;
    let text = name;
    switch(styleClass){
        case (0, $dqd8N.OPERATION_IDS).DELETE:
            if ((0, $4cTDP.fg)('issue_deletion_two_step_process_free_standard')) onClick = onClickOpenIssueDeleteModal;
            break;
        case (0, $dqd8N.OPERATION_IDS).APPROVE_APPROVAL:
            onClick = ()=>onApprove(onSuccess, onFailure);
            break;
        case (0, $dqd8N.OPERATION_IDS).REJECT_APPROVAL:
            onClick = ()=>onReject(onSuccess, onFailure);
            break;
        case (0, $dqd8N.OPERATION_IDS).RANK_TO_TOP:
            onClick = ()=>onRankToTop(onSuccess, onFailure);
            break;
        case (0, $dqd8N.OPERATION_IDS).RANK_TO_BOTTOM:
            onClick = ()=>onRankToBottom(onSuccess, onFailure);
            break;
        case (0, $dqd8N.OPERATION_IDS).ADD_FIELD:
            onClick = ()=>onAddFieldClick(elementToFocusOnClose);
            break;
        case (0, $dqd8N.OPERATION_IDS).CREATE_SUBTASK:
            onClick = onClickOpenCreateSubTaskIssueDialog;
            break;
        case (0, $dqd8N.OPERATION_IDS).PERMISSION_HELPER:
            onClick = ()=>(0, $eVOjw.permissionHelper)(elementToFocusOnClose);
            break;
        case (0, $dqd8N.OPERATION_IDS).NOTIFICATION_HELPER:
            onClick = (0, $eVOjw.notificationHelper);
            break;
        case (0, $dqd8N.LINK_IDS).LINK_ISSUE:
            text = formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $eQfx2.default).linkIssueIssueTerminologyRefreshM4 : (0, $eQfx2.default).linkIssue);
            break;
        case (0, $dqd8N.LINK_IDS).LINK_CONFLUENCE_PAGE:
            text = formatMessage((0, $eQfx2.default).linkConfluencePage);
            break;
        case (0, $dqd8N.LINK_IDS).ADD_WEB_LINK:
            text = formatMessage((0, $eQfx2.default).addWebLink);
            break;
        case (0, $dqd8N.OPERATION_IDS).ATTACH_FILE:
            // Remove with cleanup of empanada_nin_convert_issue_ops_to_entrypoint
            onClick = ()=>setDialogContext((0, $dqd8N.OPERATION_IDS).ATTACH_FILE, issueId, issueKey, uploadPermissions, workType);
            break;
        case (0, $dqd8N.OPERATION_IDS).ARCHIVE:
            onClick = ()=>onClickOpenIssueArchiveModal();
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: styleClass,
        onClick: ()=>{
            onClick();
            onFireAnalyticsEvent(styleClass);
            onClose?.();
        },
        "data-issueid": issueId,
        "data-issuekey": issueKey,
        "data-url": url,
        testId: "issue-navigator-issue-operations.ui.dropdown-menu-group.button-item.button-item"
    }, text);
};
var $2b56ad49f4d71834$export$2e2bcd8739ae039 = $2b56ad49f4d71834$export$37946c7734078e9;

});
parcelRegister("7BKle", function(module, exports) {
$parcel$export(module.exports, "ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY", () => $2582ae2409307da1$export$2ac06baa43be057);
$parcel$export(module.exports, "ESC_KEY", () => $2582ae2409307da1$export$45f4d5e73efcfde8);
$parcel$export(module.exports, "ISSUE_VIEW_URL_REGEX", () => $2582ae2409307da1$export$cbf34536d6076514);
$parcel$export(module.exports, "ISSUE_ARCHIVE_API", () => $2582ae2409307da1$export$1c9d135d7bb1047);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_VIEW", () => $2582ae2409307da1$export$501c618f5224bbb);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_NAVIGATOR", () => $2582ae2409307da1$export$f64573f447a64548);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_BOARD_VIEW", () => $2582ae2409307da1$export$a1eb5fb00be2a7d1);
const $2582ae2409307da1$export$2ac06baa43be057 = 'small';
const $2582ae2409307da1$export$45f4d5e73efcfde8 = 'Escape';
const $2582ae2409307da1$export$cbf34536d6076514 = /.*\/browse\/[^/]+/;
const $2582ae2409307da1$export$1c9d135d7bb1047 = '/rest/api/2/issue/archive';
const $2582ae2409307da1$export$501c618f5224bbb = 'issue-view';
const $2582ae2409307da1$export$f64573f447a64548 = 'issue-navigator';
const $2582ae2409307da1$export$a1eb5fb00be2a7d1 = 'board-view';

});

parcelRegister("1jlQo", function(module, exports) {
$parcel$export(module.exports, "ArchiveIssueModalStore", () => $1f0dc38b9d91d9f3$export$c5cad849002b274b);
$parcel$export(module.exports, "useArchiveIssueModalActions", () => $1f0dc38b9d91d9f3$export$b7e685898567f722);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $1gxLs = parcelRequire("1gxLs");

var $k3WVB = parcelRequire("k3WVB");
const $1f0dc38b9d91d9f3$export$c5cad849002b274b = (0, $GtRbT.createStore)({
    initialState: $k3WVB.initialState,
    actions: (0, $1gxLs.ArchiveIssueModalActions),
    name: 'archiveIssueModalStore'
});
const $1f0dc38b9d91d9f3$export$b7e685898567f722 = (0, $iJq0l.createActionsHook)($1f0dc38b9d91d9f3$export$c5cad849002b274b);

});
parcelRegister("1gxLs", function(module, exports) {
$parcel$export(module.exports, "ArchiveIssueModalActions", () => $9ee98558093ad151$export$69579d834733fb34);

var $12DRg = parcelRequire("12DRg");

var $cxKOj = parcelRequire("cxKOj");
const $9ee98558093ad151$export$69579d834733fb34 = {
    openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onChildIssuesArchiveSuccess: onChildIssuesArchiveSuccess, onDeleteIssuesFromNINView: onDeleteIssuesFromNINView, onCloseIssueViewModal: onCloseIssueViewModal, triggerPointKey: triggerPointKey, workType: workType, issueHierarchyLevel: issueHierarchyLevel })=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: true,
                issueKey: issueKey,
                issueId: issueId,
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                onChildIssuesArchiveSuccess: onChildIssuesArchiveSuccess,
                onDeleteIssuesFromNINView: (0, $cxKOj.expVal)('child-issue-archival-ga', 'isEnabled', false) ? onDeleteIssuesFromNINView : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                onCloseIssueViewModal: onCloseIssueViewModal,
                triggerPointKey: triggerPointKey,
                workType: workType,
                issueHierarchyLevel: issueHierarchyLevel
            });
        },
    closeArchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: false,
                issueKey: null,
                issueId: null,
                onIssueArchiveSuccess: null,
                onChildIssuesArchiveSuccess: null,
                onDeleteIssuesFromNINView: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                onCloseIssueViewModal: null,
                triggerPointKey: null,
                workType: null
            });
        }
};

});

parcelRegister("k3WVB", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $99d9d2d78573a32f$export$d4c72bab9d6cc13a);

var $12DRg = parcelRequire("12DRg");
const $99d9d2d78573a32f$export$d4c72bab9d6cc13a = {
    isArchiveIssueModalOpen: false,
    issueKey: null,
    issueId: null,
    onIssueArchiveSuccess: null,
    onChildIssuesArchiveSuccess: null,
    onDeleteIssuesFromNINView: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCloseIssueViewModal: null,
    triggerPointKey: null,
    workType: null
};

});


parcelRegister("eVOjw", function(module, exports) {
$parcel$export(module.exports, "fireSuccessAnalytics", () => $f3fb7d5afc428ab5$export$e5b4271d9c5c1be6);
$parcel$export(module.exports, "loadDialog", () => $f3fb7d5afc428ab5$export$9ba4d4456b84bf04);
$parcel$export(module.exports, "openCreateSubTaskIssueDialog", () => $f3fb7d5afc428ab5$export$891ceecfea203bf6);
$parcel$export(module.exports, "permissionHelper", () => $f3fb7d5afc428ab5$export$c14af1843fb5f174);
$parcel$export(module.exports, "notificationHelper", () => $f3fb7d5afc428ab5$export$e5a67cac85aad7bf);

var $gjeS9 = parcelRequire("gjeS9");

var $dqd8N = parcelRequire("dqd8N");

var $kIz4h = parcelRequire("kIz4h");

var $kRgKj = parcelRequire("kRgKj");

var $a8PVz = parcelRequire("a8PVz");
const $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID = 'issueOperationsMeatballMenu';
const $f3fb7d5afc428ab5$export$e5b4271d9c5c1be6 = (analyticsEvent, styleClass)=>{
    switch(styleClass){
        case (0, $dqd8N.OPERATION_IDS).COMMENT_ISSUE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'comment created', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).LOG_WORK:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'worklogModal added', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).CREATE_SUBTASK:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'issue created', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID, {
                isSubtask: true
            });
            break;
        case (0, $dqd8N.OPERATION_IDS).WATCH_ISSUE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'watchers startWatching', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID, {
                isSubtask: true
            });
            break;
        case (0, $dqd8N.OPERATION_IDS).UNWATCH_ISSUE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'watchers stopWatching', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID, {
                isSubtask: true
            });
            break;
        case (0, $dqd8N.OPERATION_IDS).LABELS:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'issueFields updated', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID, {
                fieldType: 'labels',
                isReusableField: true,
                updatedField: 'labels'
            });
            break;
        case (0, $dqd8N.OPERATION_IDS).LINK_ISSUE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'linkedIssue succeeded', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).ADD_WEB_LINK:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'webLink added', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).LINK_CONFLUENCE_PAGE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'linkedConfluencePage added', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).CLONE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'issue cloned', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID, {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                issueClonedIssueId: window.JIRA.IssueNavigator.getSelectedIssueId
            });
            break;
        case (0, $dqd8N.OPERATION_IDS).DELETE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'issue deleted', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).RANK_TO_BOTTOM:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'issue rankedToBottom', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).RANK_TO_TOP:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'issue rankedToTop', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID);
            break;
        case (0, $dqd8N.OPERATION_IDS).ADD_VOTE:
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'field updated', $f3fb7d5afc428ab5$var$ACTION_SUBJECT_ID, {
                fieldKey: 'votes',
                fieldType: 'votes'
            });
            break;
        default:
    }
};
const $f3fb7d5afc428ab5$export$9ba4d4456b84bf04 = async ({ styleClass: styleClass, url: url, onSuccess: onSuccess, onFailure: onFailure, issueId: issueId, accountId: accountId, elementToFocusOnClose: elementToFocusOnClose })=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const FormDialog = await (0, $gjeS9.loadBridge)({
        name: 'jira/dialog/form-dialog'
    });
    const isVoteWatchOrAssign = styleClass === (0, $dqd8N.OPERATION_IDS).ADD_VOTE || (0, $dqd8N.OPERATION_IDS).REMOVE_VOTE || (0, $dqd8N.OPERATION_IDS).WATCH_ISSUE || (0, $dqd8N.OPERATION_IDS).UNWATCH_ISSUE || (0, $dqd8N.OPERATION_IDS).ASSIGN || (0, $dqd8N.OPERATION_IDS).ASSIGN_TO_ME;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "issueaction-assign-issue": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; readonly "issueaction-assign-to-me hide-from-opsbar": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; ... 5 more ...; readonly "issueaction-edit-labels": { ...; }; }'.
    const dialogData = (0, $dqd8N.DIALOG_DATA)[styleClass];
    const ajaxOptions = {
        ...isVoteWatchOrAssign && {
            type: 'post'
        },
        url: url,
        data: {
            decorator: 'dialog',
            inline: 'true',
            ...styleClass === (0, $dqd8N.OPERATION_IDS).ASSIGN && {
                id: issueId
            },
            ...styleClass === (0, $dqd8N.OPERATION_IDS).ASSIGN_TO_ME && {
                id: issueId,
                atl_token: (0, $kIz4h.default)(),
                assignee: accountId
            },
            ...styleClass === (0, $dqd8N.OPERATION_IDS).WATCH_ISSUE && {
                id: issueId,
                atl_token: (0, $kIz4h.default)(),
                watch: 'watch'
            },
            ...styleClass === (0, $dqd8N.OPERATION_IDS).UNWATCH_ISSUE && {
                id: issueId,
                atl_token: (0, $kIz4h.default)(),
                watch: 'unwatch'
            },
            ...styleClass === (0, $dqd8N.OPERATION_IDS).ADD_VOTE && {
                id: issueId,
                atl_token: (0, $kIz4h.default)(),
                vote: 'vote'
            },
            ...styleClass === (0, $dqd8N.OPERATION_IDS).REMOVE_VOTE && {
                id: issueId,
                atl_token: (0, $kIz4h.default)(),
                vote: 'unvote'
            }
        }
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    new FormDialog({
        ...dialogData && {
            id: dialogData?.id
        },
        elementToFocusOnClose: elementToFocusOnClose,
        ajaxOptions: ajaxOptions,
        autoClose: true,
        widthClass: 'large',
        onDialogFinished: onSuccess,
        onUnSuccessfulSubmit: onFailure,
        isIssueDialog: true
    }).show();
};
const $f3fb7d5afc428ab5$export$891ceecfea203bf6 = async ({ onDismissAfterCreate: onDismissAfterCreate })=>{
    await (0, $a8PVz.asyncWrmRequire)([
        'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue'
    ]);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const form = window.JIRA.Forms.createSubtaskForm();
    form.bind('sessionComplete', ()=>{
        // Fires when at least one successful subtask creation
        onDismissAfterCreate();
    });
    form.asDialog().show();
};
const $f3fb7d5afc428ab5$export$c14af1843fb5f174 = async (elementToFocusOnClose)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const Dialog = await (0, $gjeS9.loadBridge)({
        name: 'jira/admin-helper/dialog',
        wrmKeys: 'wrc!com.atlassian.jira.plugins.jira-admin-helper-plugin:dialog-resources'
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    new Dialog({
        id: 'permission-helper-dialog',
        widthClass: 'medium',
        elementToFocusOnClose: elementToFocusOnClose,
        // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
        content: function content(callback) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.require([
                'jira/admin-helper/permission-helper/content-loader'
            ], // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (ContentLoader)=>{
                ContentLoader.loadContent(this, callback);
            });
        }
    }).show();
};
const $f3fb7d5afc428ab5$export$e5a67cac85aad7bf = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const Dialog = await (0, $gjeS9.loadBridge)({
        name: 'jira/admin-helper/dialog',
        wrmKeys: 'wrc!com.atlassian.jira.plugins.jira-admin-helper-plugin:dialog-resources'
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    new Dialog({
        id: 'notification-helper-dialog',
        widthClass: 'medium',
        // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
        content: function content(callback) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.require([
                'jira/admin-helper/notification-helper/content-loader'
            ], // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (ContentLoader)=>{
                ContentLoader.loadContent(this, callback);
            });
        }
    }).show();
};

});

parcelRegister("cTddL", function(module, exports) {
$parcel$export(module.exports, "DialogContextContainer", () => $d4ef871676e174ab$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $d4ef871676e174ab$export$a2a00ec2da7337e);
// Remove references to Dialog Context Provider on clean up of empanada_nin_convert_issue_ops_to_entrypoint
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $d4ef871676e174ab$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    workType: null,
    mediaUploadContext: null
};
const $d4ef871676e174ab$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext, workType)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext,
                workType: workType
            });
        }
};
const $d4ef871676e174ab$var$Store = (0, $GtRbT.createStore)({
    initialState: $d4ef871676e174ab$var$initialState,
    actions: $d4ef871676e174ab$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $d4ef871676e174ab$export$8e9ef3fae6d51d86 = (0, $6E16M.createContainer)($d4ef871676e174ab$var$Store);
const $d4ef871676e174ab$export$a2a00ec2da7337e = (0, $iJq0l.createHook)($d4ef871676e174ab$var$Store);

});

parcelRegister("9bIo2", function(module, exports) {
$parcel$export(module.exports, "DeleteIssueModalStore", () => $f7f926b9046bb506$export$d1e440480df04);
$parcel$export(module.exports, "useDeleteIssueModalActions", () => $f7f926b9046bb506$export$ec8cd1345f95f9aa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $ha2c5 = parcelRequire("ha2c5");

var $koLmH = parcelRequire("koLmH");
const $f7f926b9046bb506$export$d1e440480df04 = (0, $GtRbT.createStore)({
    initialState: $koLmH.initialState,
    actions: (0, $ha2c5.DeleteIssueModalActions),
    name: 'DeleteIssueModalStore'
});
const $f7f926b9046bb506$export$ec8cd1345f95f9aa = (0, $iJq0l.createActionsHook)($f7f926b9046bb506$export$d1e440480df04);

});
parcelRegister("ha2c5", function(module, exports) {
$parcel$export(module.exports, "DeleteIssueModalActions", () => $b92588e4aaa777f4$export$af54eec6d7dd9751);
const $b92588e4aaa777f4$var$noop = ()=>{
    return null;
};
const $b92588e4aaa777f4$export$af54eec6d7dd9751 = {
    openDeleteIssueModal: ({ isIssueArchivalEnabled: isIssueArchivalEnabled, workType: workType, issueKey: issueKey, issueId: issueId, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onTriggerDeleteRequest: onTriggerDeleteRequest })=>({ setState: setState })=>{
            setState({
                isDeleteIssueModalOpen: true,
                isIssueArchivalEnabled: isIssueArchivalEnabled,
                workType: workType,
                issueKey: issueKey,
                issueId: issueId,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                onIssueDeleteFailure: onIssueDeleteFailure,
                onTriggerDeleteRequest: onTriggerDeleteRequest
            });
        },
    closeDeleteIssueModal: ()=>({ setState: setState })=>{
            setState({
                isDeleteIssueModalOpen: false,
                didIssueDeleteFail: false,
                isDeletingIssue: false,
                issueKey: '',
                issueId: '',
                isIssueArchivalEnabled: false,
                workType: null,
                onIssueDeleteSuccess: $b92588e4aaa777f4$var$noop,
                onIssueDeleteFailure: $b92588e4aaa777f4$var$noop,
                onTriggerDeleteRequest: $b92588e4aaa777f4$var$noop
            });
        },
    startDeleteIssue: ()=>({ setState: setState })=>{
            setState({
                isDeletingIssue: true
            });
        },
    endDeleteIssue: ({ didIssueDeleteFail: didIssueDeleteFail })=>({ setState: setState })=>{
            setState({
                isDeletingIssue: false,
                didIssueDeleteFail: didIssueDeleteFail
            });
        }
};

});

parcelRegister("koLmH", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $a810b026a0078b26$export$d4c72bab9d6cc13a);
const $a810b026a0078b26$var$noop = ()=>{
    return null;
};
const $a810b026a0078b26$export$d4c72bab9d6cc13a = {
    isDeleteIssueModalOpen: false,
    didIssueDeleteFail: false,
    isDeletingIssue: false,
    issueKey: '',
    issueId: '',
    workType: null,
    isIssueArchivalEnabled: false,
    onIssueDeleteSuccess: $a810b026a0078b26$var$noop,
    onIssueDeleteFailure: $a810b026a0078b26$var$noop,
    onTriggerDeleteRequest: $a810b026a0078b26$var$noop
};

});


parcelRegister("iPZU8", function(module, exports) {
$parcel$export(module.exports, "useDeleteIssue", () => $9f089df5044de9ae$export$43383fdc9fe04fe6);

var $eJOHy = parcelRequire("eJOHy");

var $3ugTQ = parcelRequire("3ugTQ");
const $9f089df5044de9ae$var$getDeletionUrl = (issueKey)=>`/rest/api/3/issue/${issueKey}?deleteSubtasks=true`;
const $9f089df5044de9ae$export$43383fdc9fe04fe6 = ()=>(0, $eJOHy.useCallback)(({ issueKey: issueKey })=>(0, $3ugTQ.performDeleteRequest)($9f089df5044de9ae$var$getDeletionUrl(issueKey), {
            method: 'DELETE'
        }), []);

});

parcelRegister("hAtbw", function(module, exports) {
$parcel$export(module.exports, "useIssueOperationFlags", () => $d39a804c1ee08b8d$export$73c4e88233824270);
$parcel$export(module.exports, "default", () => $d39a804c1ee08b8d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3wl9L = parcelRequire("3wl9L");

var $80DPg = parcelRequire("80DPg");

var $4cTDP = parcelRequire("4cTDP");

var $6baZD = parcelRequire("6baZD");

var $7xE6h = parcelRequire("7xE6h");

var $lRq8t = parcelRequire("lRq8t");

var $cSXp8 = parcelRequire("cSXp8");

var $eLNTv = parcelRequire("eLNTv");

var $2va5p = parcelRequire("2va5p");
const $d39a804c1ee08b8d$export$73c4e88233824270 = (issueKey)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    return (0, $eJOHy.useCallback)((styleClass, isSuccessful)=>{
        const messageId = 'issue-navigator-issue-operations.ui.notification-flag-group.show-flag.auto-dismiss-flag';
        const messageType = 'transactional';
        const isAutoDismiss = true;
        return isSuccessful ? showFlag({
            messageId: messageId,
            messageType: messageType,
            isAutoDismiss: isAutoDismiss,
            type: 'success',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $eLNTv.default).successTitleIssueTerminologyRefreshM4 : (0, $eLNTv.default).successTitle),
            description: formatMessage((0, $eLNTv.default)[(0, $2va5p.getMessageId)(styleClass)], {
                issueKey: issueKey
            })
        }) : showFlag({
            messageId: messageId,
            messageType: messageType,
            isAutoDismiss: isAutoDismiss,
            type: 'error',
            title: formatMessage((0, $eLNTv.default).errorTitle),
            description: formatMessage((0, $eLNTv.default).errorDesc, {
                issueKey: issueKey
            })
        });
    }, [
        formatMessage,
        issueKey,
        showFlag
    ]);
};
// look into if we can clean this up with empanada_nin_convert_issue_ops_to_entrypoint
const $d39a804c1ee08b8d$var$NotificationFlagGroup = ({ flags: flags, onDismiss: onDismiss, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7xE6h.default), {
        onDismissed: onDismiss
    }, flags.map(({ id: id, styleClass: styleClass, isSuccessful: isSuccessful })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6baZD.default), {
            id: id,
            messageId: "issue-navigator-issue-operations.ui.notification-flag-group.auto-dismiss-flag",
            messageType: "transactional",
            icon: isSuccessful ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
                label: "Success",
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
                label: "Error",
                spacing: "spacious",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            key: id,
            title: isSuccessful ? formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $eLNTv.default).successTitleIssueTerminologyRefreshM4 : (0, $eLNTv.default).successTitle) : formatMessage((0, $eLNTv.default).errorTitle),
            description: isSuccessful ? formatMessage((0, $eLNTv.default)[(0, $2va5p.getMessageId)(styleClass)], {
                issueKey: issueKey
            }) : formatMessage((0, $eLNTv.default).errorDesc, {
                issueKey: issueKey
            })
        })));
};
var $d39a804c1ee08b8d$export$2e2bcd8739ae039 = $d39a804c1ee08b8d$var$NotificationFlagGroup;

});
parcelRegister("6baZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9a60bbb18d8a09b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $2pgjF = parcelRequire("2pgjF");
const $d9a60bbb18d8a09b$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $d9a60bbb18d8a09b$export$2e2bcd8739ae039 = $d9a60bbb18d8a09b$var$AkAutoDismissFlag;

});

parcelRegister("7xE6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $81717f6310abc3dd$export$2e2bcd8739ae039);

var $2pgjF = parcelRequire("2pgjF");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$81717f6310abc3dd$export$2e2bcd8739ae039 = (0, $2pgjF.FlagGroup);

});

parcelRegister("eLNTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $472eccf6dde33d6e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $472eccf6dde33d6e$var$messages = (0, $7qGN1.defineMessages)({
    thanksIssueUpdated: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-updated",
        "defaultMessage": "{issueKey} has been updated"
    },
    thanksIssueAssigned: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-assigned",
        "defaultMessage": "{issueKey} has been assigned."
    },
    thanksIssueCommented: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-commented",
        "defaultMessage": "{issueKey} has been updated with your comment."
    },
    thanksIssueWorklogged: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-worklogged",
        "defaultMessage": "Work has been logged on {issueKey}."
    },
    thanksIssueVoted: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-voted",
        "defaultMessage": "Your vote on {issueKey} has been updated."
    },
    thanksIssueWatched: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-watched",
        "defaultMessage": "Your watcher status on {issueKey} has been updated."
    },
    thanksIssueMoved: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-moved",
        "defaultMessage": "{issueKey} has been moved."
    },
    thanksIssueLinked: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-linked",
        "defaultMessage": "The links on {issueKey} have been updated."
    },
    thanksIssueCloned: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-cloned",
        "defaultMessage": "{issueKey} has been cloned."
    },
    thanksIssueLabelled: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-labelled",
        "defaultMessage": "The labels on {issueKey} have been updated."
    },
    thanksIssueDeleted: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-deleted",
        "defaultMessage": "{issueKey} has been deleted."
    },
    thanksIssueAttached: {
        "id": "issue-navigator-issue-operations.notification-flag-group.thanks-issue-attached",
        "defaultMessage": "The file(s) have been attached to {issueKey}."
    },
    successTitle: {
        "id": "issue-navigator-issue-operations.notification-flag-group.success-title",
        "defaultMessage": "Issue updated"
    },
    errorTitle: {
        "id": "issue-navigator-issue-operations.notification-flag-group.error-title",
        "defaultMessage": "Error"
    },
    errorDesc: {
        "id": "issue-navigator-issue-operations.notification-flag-group.error-desc",
        "defaultMessage": "Your operation on {issueKey} could not be performed."
    },
    successTitleIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.notification-flag-group.success-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work item updated"
    }
});
var $472eccf6dde33d6e$export$2e2bcd8739ae039 = $472eccf6dde33d6e$var$messages;

});

parcelRegister("2va5p", function(module, exports) {
$parcel$export(module.exports, "getMessageId", () => $ff5221fa47f627d4$export$7a6ec380c1221521);

var $dqd8N = parcelRequire("dqd8N");
const $ff5221fa47f627d4$export$7a6ec380c1221521 = (styleClass)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "issueaction-assign-issue": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; readonly "issueaction-assign-to-me hide-from-opsbar": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; ... 5 more ...; readonly "issueaction-edit-labels": { ...; }; }'.
    (0, $dqd8N.DIALOG_DATA)[styleClass]?.issueMsg ?? 'thanksIssueUpdated';

});


parcelRegister("eQfx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8e109cf67330fbf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d8e109cf67330fbf$var$messages = (0, $7qGN1.defineMessages)({
    linkIssue: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.button-item.link-issue",
        "defaultMessage": "Link issue"
    },
    linkConfluencePage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.button-item.link-confluence-page",
        "defaultMessage": "Link Confluence page"
    },
    addWebLink: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.button-item.add-web-link",
        "defaultMessage": "Add web link"
    },
    attachFile: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.button-item.attach-file",
        "defaultMessage": "Attach file"
    },
    linkIssueIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.button-item.link-issue-issue-terminology-refresh-m4",
        "defaultMessage": "Link work item"
    }
});
var $d8e109cf67330fbf$export$2e2bcd8739ae039 = $d8e109cf67330fbf$var$messages;

});


parcelRegister("b6Ade", function(module, exports) {
$parcel$export(module.exports, "default", () => $59fc814a75bf4f1d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $59fc814a75bf4f1d$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.retry-message",
        "defaultMessage": "Click to retry"
    },
    viewIssueLabel: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.view-issue-label",
        "defaultMessage": "View Issue"
    },
    viewIssueLabelIssueTerminologyRefreshM4: {
        "id": "issue-navigator-issue-operations.dropdown-menu-group.view-issue-label-issue-terminology-refresh-m4",
        "defaultMessage": "View work item"
    }
});
var $59fc814a75bf4f1d$export$2e2bcd8739ae039 = $59fc814a75bf4f1d$var$messages;

});

parcelRegister("3UGvB", function(module, exports) {
$parcel$export(module.exports, "RouteLinkItemOld", () => $355340c558b17305$export$2a2c047dfd42a170);
$parcel$export(module.exports, "RouteLinkItem", () => $355340c558b17305$export$5885e1e37551a766);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jYYbf = parcelRequire("jYYbf");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $6Ly9I = parcelRequire("6Ly9I");

var $c9uTK = parcelRequire("c9uTK");
const $355340c558b17305$export$2a2c047dfd42a170 = ({ rel: rel, target: target, styleClass: styleClass, onClick: onClick, name: name, ...props })=>{
    const webItemLinkRef = (0, $eJOHy.useRef)(null);
    const onClickWebItem = (e)=>{
        if (webItemLinkRef.current?.classList.contains('ap-dialog')) {
            e.preventDefault();
            webItemLinkRef.current?.click();
        }
        onClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        component: (0, $c9uTK.Link),
        rel: rel ?? target === '_blank' ? 'noopener noreferrer' : '',
        target: target,
        prefetch: "hover",
        onClick: onClickWebItem,
        ...props
    }), styleClass && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($355340c558b17305$var$HiddenLink, {
        ref: webItemLinkRef,
        href: props.href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: styleClass
    }, name));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $355340c558b17305$var$HiddenLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $355340c558b17305$export$5885e1e37551a766 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('nin_trigger_connect_webitem_dialog'), (0, $6Ly9I.MeatballMenuItemLink), $355340c558b17305$export$2a2c047dfd42a170);

});
parcelRegister("6Ly9I", function(module, exports) {
$parcel$export(module.exports, "MeatballMenuItemLink", () => $605d01337040a1b0$export$115a1882551c6dd8);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $jYYbf = parcelRequire("jYYbf");

var $cGvTS = parcelRequire("cGvTS");

var $kRgKj = parcelRequire("kRgKj");
const $605d01337040a1b0$export$115a1882551c6dd8 = ({ rel: rel, target: target, styleClass: styleClass = '', onClick: onClick, href: href, menuItemId: menuItemId, actionSubjectId: actionSubjectId = 'meatballMenu', children: children, ...props })=>{
    const webItemLinkRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked'
    });
    const onClickWebItem = (e)=>{
        (0, $cGvTS.withConnectHost)((connectHost)=>{
            if (webItemLinkRef.current && styleClass && href) connectHost.triggerWebItem(webItemLinkRef.current, styleClass, href);
        });
        if ((0, $cGvTS.isConnectDialogWebItem)(styleClass)) {
            e.preventDefault();
            e.stopPropagation();
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dropdownItem clicked', actionSubjectId, {
                menuItemId: menuItemId
            });
        } else onClick(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        rel: rel ?? target === '_blank' ? 'noopener noreferrer' : '',
        target: target,
        onClick: onClickWebItem,
        ref: (ref)=>{
            if (ref) webItemLinkRef.current = ref;
        },
        href: href,
        ...props
    }, children);
};

});





//# sourceMappingURL=async-meatball-menu.2ea0471a.js.map
